import { createSlice } from "@reduxjs/toolkit";

export const usersSlice = createSlice({
  name: "users",
  initialState: {
    workspace: null,
    space: null,
  },
  reducers: {
    setWorkspaceUsers: (state, action) => {
      state.workspace = action.payload;
    },
    setSpaceUsers: (state, action) => {
      state.space = action.payload;
    },
  },
});

export const { setWorkspaceUsers, setSpaceUsers } = usersSlice.actions;
export default usersSlice.reducer;
